import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ovulation',
  component: () => import('../../routes/OvulationCalculator.svelte'),
  card: {
    id: 'ovulation',
    title: 'Ovulation Calculator',
    description: 'Calculate your ovulation date, fertile window, and next period based on your menstrual cycle.',
    icon: 'egg',
    iconBgClass: 'bg-pink-100 dark:bg-pink-900/20',
    iconTextClass: 'text-pink-600 dark:text-pink-400',
    href: '/ovulation',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Ovulation Calculator — Find Your Fertile Window | EazyCalculators',
    description: 'Free ovulation calculator to estimate your ovulation date, fertile window, and next period. Enter your last menstrual period and cycle length.',
  },
};

export default meta;